import React, { useState } from 'react';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useCollection } from '../../hooks/useCollection';
import { slugify } from '../../utils/slugify';
import ImageUploader from './ImageUploader';

const EMPTY = {
  titulo: '', descripcionCorta: '', descripcionLarga: '', docentes: '',
  dia: '', fecha: '', horario: '', ubicacion: '', inicio: '', valor: '',
  requisitos: '', cupo: '', imagen: '', link: '',
  link_1: '', link_1_label: '', link_2: '', link_2_label: '', orden: 0,
};

const AdminCultura = () => {
  const { docs, loading } = useCollection('cultura');
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [guardando, setGuardando] = useState(false);

  const abrirNuevo = () => { setForm(EMPTY); setEditando('nuevo'); };
  const abrirEdicion = (c) => { setForm({ ...EMPTY, ...c }); setEditando(c.slug); };
  const cerrar = () => setEditando(null);

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    const slug = editando === 'nuevo' ? slugify(form.titulo) : editando;
    await setDoc(doc(db, 'cultura', slug), { ...form, slug });
    setGuardando(false);
    cerrar();
  };

  const eliminar = async (slug) => {
    if (!window.confirm('¿Eliminar este taller?')) return;
    await deleteDoc(doc(db, 'cultura', slug));
  };

  if (loading) return <p>Cargando...</p>;

  if (editando) return (
    <form className="admin-form" onSubmit={guardar}>
      <h2>{editando === 'nuevo' ? 'Nuevo taller/actividad' : 'Editar taller/actividad'}</h2>

      <label>Título *</label>
      <input value={form.titulo} onChange={e => set('titulo', e.target.value)} required />

      <label>Descripción corta *</label>
      <textarea value={form.descripcionCorta} onChange={e => set('descripcionCorta', e.target.value)} rows={3} required />

      <label>Descripción larga</label>
      <textarea value={form.descripcionLarga} onChange={e => set('descripcionLarga', e.target.value)} rows={8} />

      <label>Docentes / Coordinación</label>
      <input value={form.docentes} onChange={e => set('docentes', e.target.value)} />

      <label>Día</label>
      <input value={form.dia} onChange={e => set('dia', e.target.value)} placeholder="ej: Lunes" />

      <label>Fecha de inicio</label>
      <input value={form.fecha} onChange={e => set('fecha', e.target.value)} placeholder="ej: Inicio 08/06/26" />

      <label>Inicio (detalle)</label>
      <input value={form.inicio} onChange={e => set('inicio', e.target.value)} />

      <label>Horario</label>
      <input value={form.horario} onChange={e => set('horario', e.target.value)} placeholder="ej: 17:30 a 19:30" />

      <label>Ubicación</label>
      <input value={form.ubicacion} onChange={e => set('ubicacion', e.target.value)} />

      <label>Valor</label>
      <textarea value={form.valor} onChange={e => set('valor', e.target.value)} rows={3} />

      <label>Requisitos</label>
      <input value={form.requisitos} onChange={e => set('requisitos', e.target.value)} />

      <label>Cupo</label>
      <input value={form.cupo} onChange={e => set('cupo', e.target.value)} />

      <label>Imagen</label>
      <ImageUploader folder="cultura" currentUrl={form.imagen} onUpload={url => set('imagen', url)} />
      <input value={form.imagen} onChange={e => set('imagen', e.target.value)} placeholder="URL o ruta de la imagen" />

      <label>Link de inscripción</label>
      <input value={form.link} onChange={e => set('link', e.target.value)} type="url" />

      <label>Link 1 (opcional)</label>
      <input value={form.link_1} onChange={e => set('link_1', e.target.value)} type="url" />
      <label>Etiqueta Link 1</label>
      <input value={form.link_1_label} onChange={e => set('link_1_label', e.target.value)} />

      <label>Link 2 (opcional)</label>
      <input value={form.link_2} onChange={e => set('link_2', e.target.value)} type="url" />
      <label>Etiqueta Link 2</label>
      <input value={form.link_2_label} onChange={e => set('link_2_label', e.target.value)} />

      <label>Orden de aparición (menor = primero)</label>
      <input type="number" value={form.orden} onChange={e => set('orden', Number(e.target.value))} />

      <div className="admin-form-actions">
        <button type="submit" className="admin-btn admin-btn-primary" disabled={guardando}>
          {guardando ? 'Guardando...' : 'Guardar'}
        </button>
        <button type="button" className="admin-btn" onClick={cerrar}>Cancelar</button>
      </div>
    </form>
  );

  return (
    <div>
      <div className="admin-section-header">
        <h2>Cultura en la Casa</h2>
        <button className="admin-btn admin-btn-primary" onClick={abrirNuevo}>+ Nuevo taller</button>
      </div>
      <table className="admin-table">
        <thead>
          <tr><th>Orden</th><th>Título</th><th>Día</th><th>Inicio</th><th></th></tr>
        </thead>
        <tbody>
          {docs.map(c => (
            <tr key={c.id}>
              <td>{c.orden}</td>
              <td>{c.titulo}</td>
              <td>{c.dia}</td>
              <td>{c.fecha}</td>
              <td className="admin-table-actions">
                <button className="admin-btn" onClick={() => abrirEdicion(c)}>Editar</button>
                <button className="admin-btn admin-btn-danger" onClick={() => eliminar(c.slug)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminCultura;
